__webpack_require__.p = "/ke/investment/funds/";